import { MdCancel } from 'react-icons/md';
import { ReferredTo } from '../../../types/referral';

const ReferralModalTable = ({
  referredToList,
  onClickRemove,
}: {
  referredToList: Array<ReferredTo>;
  onClickRemove: (associateId: number, serviceId: number) => void;
}) => {
  // rendering referral modal table component here
  return (
    <div>
      <div className='grid grid-cols-[1fr_1fr_70px] border-2 border-dashed border-base-cyan text-center rounded-t-lg [&>p:not(:last-child)]:border-r-2 [&:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-base-cyan [&>p]:font-semibold [&>p]:text-legal-dark-blue [&>p]:py-1'>
        <p>Associate Name</p>
        <p>Service</p>
        <p></p>
      </div>

      <div className='[&>div:last-child]:rounded-b-lg [&>div]:border-t-0'>
        {referredToList.map((referral, index) => (
          <div
            key={index}
            className='grid grid-cols-[1fr_1fr_70px] border-2 border-dashed border-base-cyan text-center [&>p:not(:last-child)]:border-r-2 [&>p:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-base-cyan [&>p]:p-1'
          >
            <p title={referral.associate_name} className='w-full truncate'>
              {referral.associate_name}
            </p>
            <p title={referral.service_name} className='w-full truncate'>
              {referral.service_name}
            </p>
            <div className='flex items-center justify-center'>
              <button
                onClick={() =>
                  onClickRemove(referral.associate, referral.service)
                }
                title='Remove Referral'
                type='button'
              >
                <MdCancel className='size-5 text-base-red hover:opacity-60 active:scale-95 duration-300' />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferralModalTable;
